export const PROFILE_DISPLAY_NAME_MAX_LENGTH = 10;
export const PROFILE_PREFERRED_STYLE_EMPTY_LABEL = 'No styles found.';
export const PROFILE_PREFERRED_STYLE_INPUT_PLACEHOLDER = 'Comma-separated, e.g. indie, metalcore';
